const servicesOptions = [
  'Anger Management',
  'Anxiety Therapy',
  'Grief Counseling',
  'Depression Therapy',
  'Stress Management',
  'Trauma Therapy',
  'Addiction Counseling',
  'Relationship Counseling',
  'Family Therapy',
  'Child Therapy',
  'Adolescent Therapy',
  'Cognitive Behavioral Therapy (CBT)',
  'Dialectical Behavior Therapy (DBT)',
  'Mindfulness-Based Therapy',
  'Psychodynamic Therapy',
  'Psychoanalytic Therapy',
  'Group Therapy',
  'Career Counseling',
  'Couples Therapy',
  'Behavioral Therapy',
  'Supportive Therapy',
  'Occupational Therapy',
  'Crisis Intervention',
  'PTSD Therapy',
  'OCD Therapy',
  'Bipolar Disorder Therapy',
  'ADHD Therapy',
  'Eating Disorder Therapy',
  'Personality Disorder Therapy',
  'Sleep Disorder Therapy',
  'Pain Management',
  'Guilt Counseling',
  'Parenting Support',
  'Divorce Counseling',
  'LGBTQ+ Counseling',
  'Chronic Illness Counseling',
  'Anger Management for Children',
  'Play Therapy',
  'Art Therapy',
  'Music Therapy',
  'Hypnotherapy',
];

const supportedTestOptions = [
  'IQ test',
  'Projective tests',
  'Neurological tests (Organic)',
  'Minnesota Multiphasic Personality Inventory (MMPI)',
  'Beck Depression Inventory (BDI)',
  'Wechsler Adult Intelligence Scale (WAIS)',
  'Myers-Briggs Type Indicator (MBTI)',
  'Rorschach Inkblot Test',
  'Thematic Apperception Test (TAT)',
  'Neuropsychological Testing',
  'ADHD Assessment',
  'Autism Spectrum Disorder Assessment',
  'Personality Assessment Inventory (PAI)',
  'Cognitive Assessment',
  'Behavioral Assessment',
];

const techniqueOptions = [
  'Cognitive Behavioral Therapy (CBT)',
  'Dialectical Behavior Therapy (DBT)',
  'Satir Method',
  'Myers-Briggs Type Indicator (MBTI)',
  'Enneagram',
  'Eye Movement Desensitization and Reprocessing (EMDR)',
  'Solution-Focused Brief Therapy (SFBT)',
  'Acceptance and Commitment Therapy (ACT)',
  'Gestalt Therapy',
  'Mindfulness-Based Cognitive Therapy (MBCT)',
  'Art Therapy',
  'Music Therapy',
  'Play Therapy',
  'Narrative Therapy',
  'Interpersonal Therapy (IPT)',
  'Deep Transcranial Magnetic Stimulation (dTMS)',
];

const patientGroupOptions = ['Individuals บุคคล', 'Couples คู่', 'Families ครอบครัว', 'Groups กลุ่ม'];

export default {
  servicesOptions,
  supportedTestOptions,
  techniqueOptions,
  patientGroupOptions,
};
